module.exports = __webpack_public_path__ + "static/media/2.68edf46b.jpg";